import { Printer } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { SiteNavigationTab } from '~/pages/Home/SiteNavigation/shared/SiteNavigationTab'
import { TabImplementationProps } from '~/pages/Home/SiteNavigation/tabImplementations/TabImplementationTypes'
import { useUnreadCount } from '~/queries/faxQueries'

export const FaxTab = ({
  id,
  isSelected,
  isCollapsed,
  onClick,
}: TabImplementationProps) => {
  // The nav renders on every page, so read the unread total straight from its
  // own lightweight query rather than mounting the whole fax view model (list +
  // per-extension counts) app-wide (support 00389200 throttling).
  const { results: unreadCount } = useUnreadCount()
  const { t } = useTranslation()

  return (
    <SiteNavigationTab
      icon={Printer}
      id={id}
      isCollapsed={isCollapsed}
      isSelected={isSelected}
      notificationCount={unreadCount}
      onClick={onClick}
      title={t('nav.fax')}
    />
  )
}
